// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tFvX","left":"styles_left__imE_N","desktopActions":"styles_desktopActions__j5piB","title":"styles_title__2pMUb"};